import LeaseInformation from "./LeaseInformation";

export default LeaseInformation;